import React, { useContext } from 'react';
import styled from 'styled-components';
import { ContentWrapper, PageTitle } from '../styled-components/shared';
import { DataContext } from '../data/DataContext';
import {useTranslation} from "react-i18next";
import BottomNavLinks from '../components/BottomNavLinks';
 
const StyledSubHeader = styled.h2`
  font-size: 16px;
  color: #4c4c4c;
  margin-top: 25px;
  margin-left: 10px;
  line-height: 19px;
  font-weight: 600;
`;
 
export default function AboutPage() {
  const  {t} = useTranslation()
  const { about } = useContext(DataContext);
 
  return (
    <ContentWrapper>
      <PageTitle style={{marginLeft: '10px'}}>{t('about')}</PageTitle>
      <StyledSubHeader>{t('serverVersion')}{about.serverVersion ? about.serverVersion : <i>{t('loading__')}</i>}
      </StyledSubHeader>
      <BottomNavLinks />
    </ContentWrapper>
  )
}